var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"custom-class":"loading-box","visible":_vm.centerDialogVisible,"width":!_vm.$store.getters.isPC ? '90%' : '40%',"center":"","show-close":true},on:{"update:visible":function($event){_vm.centerDialogVisible=$event},"close":_vm.close}},[_c('div',{staticClass:"loading-icon"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }